"use client";
import { useEffect, useState } from "react";
export default function BackToTop() {
  const [visible, setVisible] = useState(false);
// data
  // Show button when scrolled down 300px
  useEffect(() => {
    const toggleVisibility = () => {
      setVisible(window.scrollY > 300);
    };
// data
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      onClick={scrollToTop}
      aria-label="Back to top"
      className={`fixed bottom-6 right-6 z-50 flex items-center justify-center
                  h-12 w-12 rounded-full bg-purple-600 text-white shadow-lg
                  hover:bg-purple-700 transition-opacity duration-300 ${
                    visible ? "opacity-100" : "opacity-0 pointer-events-none"
                  }`}
    >
      {/* Up arrow icon */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
      </svg>
    </button>
  );
}
